<template>
  <GModal class="modal--discard">
    <div slot="header"></div>

    <div slot="body" style="text-align: center">
      <img src="/assets/img/others/error-review.png" width="77" height="85" style="margin: 20px" />
      <p class="text">{{ message || defaultMessage }}</p>
    </div>

    <div slot="footer">
      <div class="group-btn">
        <div>
          <a href="" class="btn btn-publish" @click.prevent="closeModal">Ok</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'ModalError',
  props: {
    message: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    defaultMessage() {
      return this.$store.state.modal.reviewErrorMessage;
    },
  },
  beforeDestroy() {
    this.$store.commit('setReviewErrorMessage', '');
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
  },
};
</script>

<style scoped lang="scss"></style>
